import projects_overlays from '../projects_overlays/projects_overlays'

var scrolltotop_controller = {
	i: function () {
		jqueryMap.$htmlbody = jQuery('html, body')
		window.laytheme.on('newpageshown', bindScrollToTopClick)
	},
}

export default scrolltotop_controller

var jqueryMap = {
	$htmlbody: null,
}

var scrollToTopCancelEvents = 'scroll.layScrollToTop wheel.layScrollToTop DOMMouseScroll.layScrollToTop mousewheel.layScrollToTop touchmove.layScrollToTop'
var scrollToTopSelector = '.scrolltotop, .sitetitle[data-use-as-scroll-to-top="true"], .mobile-title[data-use-as-scroll-to-top="true"]'

var valuesMatch = function (a, b) {
	return a != null && b != null && String(a) === String(b)
}

var siteTitlePointsToCurrentPage = function ($siteTitle) {
	var type = $siteTitle.attr('data-type')
	var id = $siteTitle.attr('data-id')

	if (projects_overlays.isOverlayDisplayBlock()) {
		return projects_overlays.isSameStateOfLastOverview({ type: type, id: id })
	}

	return valuesMatch(jQuery('body').attr('data-type'), type) && valuesMatch(jQuery('body').attr('data-id'), id)
}

var activePageHasScrollSnap = function () {
	var selector = '.vertical-scrollsnap, .horizontal-scrollsnap, .lay-scrollsnap-footer-section'
	var $scope = projects_overlays.isOverlayDisplayBlock() ? jQuery('#lay-project-overlay') : jQuery('body > .lay-content')
	return $scope.filter(selector).add($scope.find(selector)).length > 0
}

var scrollToTop = function ($scrollToTop) {
	var isInsideScrollSnap = $scrollToTop.closest('.vertical-scrollsnap, .horizontal-scrollsnap, .lay-scrollsnap-footer-section').length > 0
	if ((isInsideScrollSnap || activePageHasScrollSnap()) && jQuery.fn.fullpage && typeof jQuery.fn.fullpage.moveToStart === 'function') {
		jQuery.fn.fullpage.moveToStart()
		return
	}

	if (jQuery('html').hasClass('fp-enabled')) {
		jQuery.fn.fullpage.moveTo(1, 0)
	} else {
		if (projects_overlays.isOverlayDisplayBlock()) {
			jQuery('#lay-project-overlay').animate({ scrollTop: 0 }, 600, 'easeOutQuint')
		} else {
			jqueryMap.$htmlbody.animate({ scrollTop: 0 }, 600, 'easeOutQuint', function () {
				jqueryMap.$htmlbody.off(scrollToTopCancelEvents)
			})
			jqueryMap.$htmlbody.off(scrollToTopCancelEvents).on(scrollToTopCancelEvents, function () {
				jqueryMap.$htmlbody.stop()
				jqueryMap.$htmlbody.off(scrollToTopCancelEvents)
			})
		}

		// maybe scroll to top inside a splitscreen?
		var $grid = $scrollToTop.closest('#grid')
		var $footer = $scrollToTop.closest('#footer-region')
		if ($grid.length > 0) {
			var gridOverflow = getComputedStyle($grid[0]).overflowY

			if (gridOverflow === 'scroll') {
				$grid.animate({ scrollTop: 0 }, 600, 'easeOutQuint')
			}
		}
		if ($footer.length > 0) {
			var footerOverflow = getComputedStyle($footer[0]).overflowY
			if (footerOverflow === 'scroll') {
				$footer.animate({ scrollTop: 0 }, 600, 'easeOutQuint')
			}
		}
	}
}

var bindScrollToTopClick = function () {
	jQuery(scrollToTopSelector).off('click.layScrollToTop')
	jQuery(scrollToTopSelector).on('click.layScrollToTop', function (e) {
		var $scrollToTop = jQuery(this)
		var isSiteTitle = $scrollToTop.is('[data-use-as-scroll-to-top="true"]')
		if (isSiteTitle && !siteTitlePointsToCurrentPage($scrollToTop)) {
			return
		}

		e.preventDefault()
		e.stopPropagation()
		scrollToTop($scrollToTop)
	})
}
